import { Injectable } from '@angular/core';
// import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class StringFormattingService {
  constructor() {}

  // formatDateRange(startDate: Date, endDate: Date, shortDate: boolean = true) {
  //   let formatString = shortDate ? 'M/D/YYYY' : 'dddd, MMMM DD, YYYY';
  //   let startDateOut = moment(startDate).format(formatString);
  //   let endDateOut = moment(endDate).format(formatString);
  //   if (startDateOut === endDateOut) return startDateOut;
  //   return 'from ' + startDateOut + ' through ' + endDateOut;
  // }

  // formatShortDate(date: any) {
  //   if (!date) return '';
  //   return moment(date).format('M/D/YYYY');
  // }

  // formatLongDate(date: any) {
  //   return moment(date).format('LLL');
  // }

  formatDecimal(number: number, decimalPlaces: number) {
    return this.formatCurrency(number, decimalPlaces).replace('$', '');
  }

  formatPercent(number: number) {
    throw new Error('Not implemented');
  }

  formatPhoneNumber(s: any): any {
    let s2 = ('' + s).replace(/\D/g, '');
    let m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return !m ? null : '(' + m[1] + ') ' + m[2] + '-' + m[3];
  }

  // formatDateStamp(date: any) {
  //   if (!date) return '';
  //   return moment(date).format('M/D/YYYY h:mm a');
  // }

  formatCurrency(amount: number, decimalPlaces: number = 2): string {
    let formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    });

    return formatter.format(amount);
  }

  // Lifted from: http://stackoverflow.com/questions/10420352/converting-file-size-in-bytes-to-human-readable
  formatFileSize(bytes: number, si: boolean = false): string {
    si = !si;
    let thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
      return bytes + ' B';
    }
    // let units = si
    //   ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    //   : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

    let units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let u = -1;
    do {
      bytes /= thresh;
      ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1) + ' ' + units[u];
  }

  // Lifted from: https://stackoverflow.com/questions/4149276/javascript-camelcase-to-regular-form
  formatTitleCase(str: string): string {
    return (
      str
        // insert a space between lower & upper
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        // space before last upper in a sequence followed by lower
        .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
        // uppercase the first character
        .replace(/^./, function (str) {
          return str.toUpperCase();
        })
        .replace(' Of ', ' of ')
        .replace(' A ', ' a ')
        .replace(' The ', ' the ')
    );
  }

  formatCamelCase(str: string): string {
    if (!str) return str;
    str = this.formatTitleCase(str);
    str = this.replaceAll(str, ' ', '');
    str = str.charAt(0).toLowerCase() + str.slice(1);
    return str;
  }

  formatPascalCase(str: string): string {
    if (!str) return str;
    str = this.formatTitleCase(str);
    str = this.replaceAll(str, ' ', '');
    str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
  }

  formatSnakeCase(str: string): string {
    if (!str) return str;
    str = this.formatTitleCase(str);
    str = this.replaceAll(str, ' ', '-');
    return str.toLowerCase();
  }

  replaceAll(str: string, find: string, replace: string): string {
    return str.split(find).join(replace);
  }

  // formatSystemAddress(address: Address, nullValue: string = 'n/a'): string {
  //   if (!address) return nullValue;

  //   return this.formatAddress(
  //     address.address1,
  //     address.address2,
  //     address.city,
  //     address.state,
  //     address.zip,
  //     nullValue
  //   );
  // }

  formatAddress(
    address1: string,
    address2: string,
    city: string,
    state: string,
    zip: string,
    nullValue: string = 'n/a'
  ): string {
    let retVal = '';
    if (address1) retVal = address1;

    if (address2) {
      if (retVal.length) retVal += '\n';
      retVal += address2;
    }

    if (city) {
      if (retVal.length) retVal += '\n';
      retVal += city;
    }

    if (state) {
      if (retVal.length) retVal += ', ';
      retVal += state;
    }

    if (zip) {
      if (retVal.length) retVal += ' ';
      retVal += zip;
    }

    if (!retVal) return nullValue;
    return retVal;
  }
}
